export default __webpack_public_path__ + "static/media/1002.fba1aaab.svg";